// extracted by mini-css-extract-plugin
export var auto = "_10-1";
export var spinner = "_10-0";